import type { ClipStatus } from "../api/types";

// Colored pill for a ClipStatus — same visual language as the recording StatusBadge,
// colors mirroring the CSS design tokens.
export const CLIP_STATUS_META: Record<
  ClipStatus,
  { label: string; color: string; active: boolean }
> = {
  queued: { label: "Queued", color: "#7c877f", active: false },
  processing: { label: "Building", color: "#6366f1", active: true },
  ready: { label: "Ready", color: "#0e8c5a", active: false },
  failed: { label: "Failed", color: "#e5342a", active: false },
};

export default function ClipStatusBadge({ status }: { status: ClipStatus }) {
  const meta = CLIP_STATUS_META[status] ?? { label: status, color: "#7c877f", active: false };
  return (
    <span className="status-badge" style={{ ["--sc" as string]: meta.color }}>
      <span className={meta.active ? "status-dot pulse" : "status-dot"} />
      {meta.label}
    </span>
  );
}
